var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleWavyWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.125V10.0625",
    stroke: "#DFDFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.4375C9.46599 13.4375 9.84375 13.0597 9.84375 12.5938C9.84375 12.1278 9.46599 11.75 9 11.75C8.53401 11.75 8.15625 12.1278 8.15625 12.5938C8.15625 13.0597 8.53401 13.4375 9 13.4375Z",
    fill: "#DFDFDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1130_22573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.98454 17.4713C13.1195 17.4713 16.4715 14.1193 16.4715 9.98437C16.4715 5.84943 13.1195 2.49739 8.98454 2.49739C4.84959 2.49739 1.49756 5.84943 1.49756 9.98437C1.49756 14.1193 4.84959 17.4713 8.98454 17.4713Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98454 6.98958V9.98437M8.98454 12.9792H8.99202M16.4715 9.98437C16.4715 14.1193 13.1195 17.4713 8.98454 17.4713C4.84959 17.4713 1.49756 14.1193 1.49756 9.98437C1.49756 5.84943 4.84959 2.49739 8.98454 2.49739C13.1195 2.49739 16.4715 5.84943 16.4715 9.98437Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1130_22573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9688,
    height: 17.9688,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWavyWarning);
export default __webpack_public_path__ + "static/media/CircleWavyWarning.b6de8c9b5760e4ddceca6db7f6bf51ca.svg";
export { ForwardRef as ReactComponent };